import { Button, Modal } from '@shared/ui';
import './PhotosBeforeShowModal.css';

interface PhotosBeforeShowModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUpload: () => void;
}

export default function PhotosBeforeShowModal({
  isOpen,
  onClose,
  onUpload,
}: PhotosBeforeShowModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Сначала загрузите фото" maxWidth={440}>
      <div className="photos-before-show">
        <p>Чтобы показать товар, добавьте фотографии в карточку.</p>
        <div className="photos-before-show__actions">
          <Button variant="secondary" onClick={onClose}>
            Закрыть
          </Button>
          <Button
            onClick={() => {
              onClose();
              onUpload();
            }}
          >
            Загрузить фото
          </Button>
        </div>
      </div>
    </Modal>
  );
}
